import sal from 'sal.js';

const ScrollAnimations = sal({
  threshold: 0.0001,
});

export default ScrollAnimations;
